import { createRouter, createWebHistory } from 'vue-router'
import WelcomeView from '../views/WelcomeView.vue'
import HomeView from '../views/HomeView.vue'
import SyllableTrainer from '../views/SyllableTrainer.vue'
import SyllableMapView from '../views/SyllableMapView.vue'
import WordTrainer from '../views/WordTrainer.vue'
import StatsView from '../views/StatsView.vue'

const routes = [
  { path: '/welcome', component: WelcomeView },
  { path: '/', component: HomeView },
  { path: '/syllables', component: SyllableTrainer },
  { path: '/syllable-map', component: SyllableMapView },
  { path: '/words', component: WordTrainer },
  { path: '/stats', component: StatsView },
]

export default createRouter({
  history: createWebHistory(),
  routes,
})
